import jsPDF from 'jspdf'
import JsBarcode from 'jsbarcode'
import autoTable from 'jspdf-autotable'
import { useSettings } from '../pages/settings/composables/useSettings'

export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Ingresa una dirección de correo válida'
  },
  required: (v: any) => !!v || 'Campo obligatorio',
  min: (v: number, value: number) => v >= value || `Mínimo permitido es ${value}`,
  max: (v: number, value: number) => v <= value || `Máximo permitido es ${value}`,
  stringBetween: (v: any, min: number, max: number) => {
    if (v) {
      return v.length >= min && v.length <= max
    }
    return false
  },
  isNumber: (v: string) => {
    const pattern = /^\d*$/
    return pattern.test(v) || 'Ingresa un número correcto'
  },
  maxLength: (v: number, value: number) =>
    (v && v.toString().length <= value) || `Numéro máximo de caracteres permitido es ${value}`,
  lengthBetween: (v: any, min: number, max: number) =>
    (v.length >= min && v.length <= max) || `Ingresar entre ${min} y ${max} caracteres`,
  identificationType: (v: any, type: string) =>
    validateIdentificationType(v, type) || `Numéro de identificación incorrecto`,
  ruc: (v: any) => validateRuc(v) || `Numéro de RUC incorrecto`,
  numberBetween: (v: number, min: number, max: number) =>
    (v >= min && v <= max) || `Numéro debe estar entre ${min} y ${max}`,
  noSpecialChars: (v: any) => {
    if (/[!@#$%^&*(),.?":{}|<>[\]\\/'`~_=+-]/g.test(v)) {
      return 'Uso de caracteres especiales no permitido'
    }
    return true
  },
  isCelular: (v: string) => {
    const pattern = /^09\d{8}$/
    return pattern.test(v) || 'Ingresa un celular correcto (09........)'
  },
  validateSRIUser: (v: string, type: string) => validateIdentificationType(v, type) || false,
  emailOrCelular: (v: string) => {
    if (!v) return 'Este campo es obligatorio'

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const celularPattern = /^09\d{8}$/

    if (emailPattern.test(v) || celularPattern.test(v)) {
      return true
    }
    return 'Ingresa un correo o celular válido (ej: correo@dominio.com o 09XXXXXXXX)'
  },
}
function validateRuc(value: string) {
  if (!/^\d{13}$/.test(value) || !/^\d{10}00\d{1}$/.test(value)) {
    return 'RUC incorrecto'
  }
  return true
}
function validateIdentificationType(value: string, type: string) {
  switch (type) {
    case '04':
      //13 dígitos, termina en 00+number (001,002,....)
      if (!/^\d{13}$/.test(value) || !/^\d{10}00\d{1}$/.test(value)) {
        return 'RUC incorrecto'
      }
      return true
    case '05':
      //10 dígitos
      if (!/^\d{10}$/.test(value)) {
        return 'Cédula incorrecta'
      }
      let total = 0
      for (let i = 0; i < value.length - 1; i++) {
        if (i % 2 === 0) {
          let aux = parseInt(value.charAt(i)) * 2
          if (aux > 9) aux -= 9
          total += aux
        } else {
          total += parseInt(value.charAt(i)) // parseInt o concatenará en lugar de sumar
        }
      }
      total = total % 10 ? 10 - (total % 10) : 0
      if (total !== parseInt(value.charAt(value.length - 1))) {
        return 'Cédula incorrecta'
      }

      return true
    default:
      return true
  }
}
export async function getPdf(item: any) {
  const logoDefault =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='

  const { fetch: getSettings, settings } = useSettings()

  await getSettings()

  const invoiceSettings = settings.value

  const logo = invoiceSettings?.invoiceLogo || logoDefault

  const doc = new jsPDF('p', 'mm', 'a4')

  const claveAcceso = item.code

  // Crear un canvas en memoria para generar el código de barras
  const canvas = document.createElement('canvas')
  // Generar el código de barras en el canvas
  JsBarcode(canvas, claveAcceso, {
    format: 'CODE128',
    displayValue: true,
  })
  // Convertir el canvas a una imagen base64
  const barcodeImage = canvas.toDataURL('image/png')
  // Datos de la factura
  const num_fac = invoiceSettings!.estab + '-' + invoiceSettings!.ptoEmi + '-' + item.number.toString().padStart(9, '0')
  const date_fac = item.date.split('T')[0]
  const datosFactura = {
    ruc: invoiceSettings!.ruc,
    factura: num_fac,
    autorizacion: item.code,
    fechaHora: date_fac,
    ambiente: item.ambienteInfo.name,
    emision: 'Normal',
    razonSocial: invoiceSettings!.razonSocial,
    direccion: invoiceSettings!.dirMatriz,
    subtotal: item.subtotal,
    descuento: '0.00',
    iva: item.tax,
    total: item.total,
  }

  // Mapeo de códigos de IVA con descripciones
  const ivaMapping = {
    0: '0%',
    2: '12%',
    3: '14%',
    4: '15%',
    5: '5%',
    6: 'No Objeto de Impuesto',
    7: 'Exento de IVA',
    8: 'IVA diferenciado',
    10: '13%',
  }

  // Inicializamos un objeto para agrupar productos por código de IVA
  const ivaData = Object.keys(ivaMapping).reduce((acc, code) => {
    acc[code] = []
    return acc
  }, {})

  // Productos
  //const productos = item.productsList;
  const { client, productsList } = item

  /*********** totalConImpuestos *************/
  // Agrupar productos por IVA y calcular valores
  productsList.forEach(({ tax, price, invoiceProductTaxInfo }) => {
    if (ivaData[invoiceProductTaxInfo.id] !== undefined) {
      ivaData[invoiceProductTaxInfo.id].push({
        baseImponible: price,
        valor: tax,
        descripcion: invoiceProductTaxInfo.name,
      })
    }
  })

  // Setup Format
  const marIzqY = 10
  const tableWidth = 90
  const marIzq = 10
  const startY = 10
  doc.setFontSize(9)

  /***********************************Izquierdo Logotipo*********************************/
  const imgBase64 = `${logo}`
  doc.addImage(imgBase64, 'PNG', marIzq, marIzqY, 40, 40)
  /***********************************Izquierda Local*********************************/

  const datosLocal = [[`${datosFactura.razonSocial}`], [`DIRECCIÓN: ${datosFactura.direccion}`]]

  autoTable(doc, {
    body: datosLocal,
    startY: 50,
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    tableWidth: tableWidth,
    margin: { left: 10, right: 10 },
  })
  /***********************************Derecho Info***************************************/
  const dataDerecho = [
    [`R.U.C: ${datosFactura.ruc}`],
    [`FACTURA`],
    [`No: ${datosFactura.factura}`],
    [`NÚMERO DE AUTORIZACIÓN:`],
    [`${datosFactura.autorizacion}`],
    [`AMBIENTE: ${datosFactura.ambiente}`],
    [`EMISIÓN: ${datosFactura.emision}`],
    [`CLAVE DE ACCESO:`],
    [],
    [],
    [],
  ]

  autoTable(doc, {
    body: dataDerecho,
    startY: startY,
    didDrawCell: (dataDerecho) => {
      if (dataDerecho.row.index === 7) {
        doc.addImage(barcodeImage, 'PNG', dataDerecho.cell.x, dataDerecho.cell.y + 5, 90, 20)
      }
    },
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    margin: { left: 110 },
    tableWidth: tableWidth,
  })

  /***********************************Centro*********************************/

  const lastTableY = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 30

  const dataCentro = [
    [`RAZÓN SOCIAL: ${client.fullname}`],
    [`IDENTIFICACIÓN: ${client.ruc}`],
    [`FECHA Y HORA: ${datosFactura.fechaHora}`],
  ]

  autoTable(doc, {
    body: dataCentro,
    startY: lastTableY + 5,
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    tableWidth: 190,
    margin: { left: 10, right: 10 },
  })

  /***********************************Centro2*********************************/
  const lastTableY2 = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 30

  const dataCentro2 = productsList.map((product: any) => [
    product.invoiceProductInfo.code,
    product.invoiceProductInfo.name,
    product.cant,
    product.price,
    '0.00',
    product.total,
  ])

  autoTable(doc, {
    head: [['Código', 'Descripción', 'Cant', 'P. Unitario', 'Descuento', 'Precio Total']],
    body: dataCentro2,
    startY: lastTableY2 + 5,
    theme: 'plain',
    tableWidth: 'auto',
    margin: { left: 10, right: 10 },
    styles: {
      lineWidth: 0.1,
      lineColor: [0, 0, 0], // bordes negros
      fontSize: 10,
    },
  })
  /***********************************Totales*********************************/
  const lastTableYFinal = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 30

  const totales = []
  Object.entries(ivaData).forEach(([codigo, items]) => {
    items.forEach(({ baseImponible, valor, descripcion }) => {
      totales.push([[`SUBTOTAL ${descripcion}`], [`$ ${baseImponible}`]])
    })
  })

  totales.push([[`DESCUENTO`], [`$ ${datosFactura.descuento}`]])
  totales.push([[`ICE`], [`$ 0.00`]])
  totales.push([[`IVA 15%`], [`$ ${datosFactura.iva}`]])
  totales.push([[`PROPINA`], [`$ 0.00`]])
  totales.push([[`TOTAL`], [`$ ${datosFactura.total}`]])

  autoTable(doc, {
    body: totales,
    startY: lastTableYFinal + 5,
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    tableWidth: tableWidth,
    margin: { left: 110 },
    styles: {
      lineWidth: 0.1,
      lineColor: [0, 0, 0], // bordes negros
      fontSize: 10,
    },
  })

  /***************************Informacion adicinal *********************/
  const infoAdicionalHeader = [['INFORMACIÓN ADICIONAL']]
  const infoAdicional = []
  const fiels = item.additionalFields

  for (const aux in fiels) {
    infoAdicional.push([`${fiels[aux].name}:`, `${fiels[aux].description}`])
  }

  autoTable(doc, {
    head: infoAdicionalHeader,
    body: infoAdicional,
    startY: lastTableYFinal + 5,
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    tableWidth: tableWidth,
    margin: { left: 10 },
  })

  /***************************Forma de pago*****************************/
  const lastTableForma = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 30

  const formaPagoHeader = [['FORMA DE PAGO']]
  const formaPago = [[`${item.paymentMethodInfo.name}`]]

  autoTable(doc, {
    head: formaPagoHeader,
    body: formaPago,
    startY: lastTableForma + 5,
    theme: 'plain',
    tableLineWidth: 0.2,
    tableLineColor: [0, 0, 0],
    tableWidth: tableWidth,
    margin: { left: 10 },
  })

  const name_fac = num_fac + '.pdf'

  doc.save(name_fac)
}
